import React from 'react';

const steps = [
  {
    icon: '🛒',
    label: 'Browse',
    desc: 'Explore thousands of products directly from AliExpress.',
  },
  {
    icon: '🎯',
    label: 'Filter',
    desc: 'Narrow your search by category, price, and relevance.',
  },
  {
    icon: '✅',
    label: 'Click to Buy',
    desc: 'Buy directly in 1-click using local currency support.',
  },
];

const HowItWorks = () => {
  return (
    <section className="bg-green-50 py-16 px-4">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-10">
          How It Works
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md p-6 transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
            >
              <div className="text-4xl mb-4 animate-bounce">{step.icon}</div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">
                {index + 1}. {step.label}
              </h3>
              <p className="text-gray-600 text-sm">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
